import React, { useEffect, useState } from 'react';
import { Logo } from '../../components/Logo';
import TestimonialCard from '../../components/onboarding/TestimonialCard';
import PrimaryButton from '../../components/common/PrimaryButton';
import { useNavigate } from 'react-router-dom';
import GlobeHuman from '../../assets/images/globe_human.png';
import { auth } from '../../config/firebase';
import { signInWithCustomToken } from 'firebase/auth';
import storage from '../../utils/storage';
import {
  Container,
  FormSection,
  TestimonialSection,
  Title,
  LogoWrapper,
  BrandText,
} from '../../styles/components';
import { typography } from '../../styles/theme';

const ThankYouPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Commented out dashboard access functionality
  /*
  const handleDashboardAccess = async () => {
    setLoading(true);
    setError('');
    try {
      // Get the custom token from local storage (stored during onboarding)
      const onboardingData = JSON.parse(localStorage.getItem('step1Data') || '{}');
      console.log('Onboarding data found:', onboardingData); // Debug log
      
      const customToken = onboardingData.customToken;
      if (!customToken) {
        console.error('No token found in storage data:', onboardingData); // Debug log
        throw new Error('No authentication token found');
      }

      console.log('Found token, attempting sign in...'); // Debug log
      // Sign in with custom token
      await signInWithCustomToken(auth, customToken);
      
      // Clear onboarding data from local storage
      localStorage.removeItem('step1Data');
      
      // Navigate to dashboard
      navigate('/dashboard');
    } catch (err) {
      console.error('Error accessing dashboard:', err);
      setError('Unable to access dashboard. Please try logging in from the homepage.');
    } finally {
      setLoading(false);
    }
  };
  */

  const handleReturnHome = () => {
    // Clear all session data after user has had chance to access dashboard
    storage.endSession();
    navigate('/');
  };

  return (
    <Container>
      <FormSection>
        <LogoWrapper>
          <Logo />
        </LogoWrapper>
        <Title style={{ textAlign: 'center' }}>Thank you for choosing <BrandText>Planet Protection</BrandText></Title>
        <div style={{ 
          textAlign: 'center', 
          maxWidth: '480px', 
          margin: '2rem auto',
          fontSize: '1.1rem',
          lineHeight: '1.6',
          fontFamily: typography.fontFamily
        }}>
          <p style={{ fontWeight: 300 }}>
            Thank you for your submission, a member of our team will be in touch with you shortly.
          </p>
          <div style={{ margin: '2rem auto' }}>
            <img 
              src={GlobeHuman} 
              alt="Globe with human illustration" 
              style={{ 
                maxWidth: '100%',
                height: 'auto',
                width: '250px'
              }} 
            />
          </div>
          <p style={{ marginTop: '2rem', fontWeight: 300 }}>
            We're excited to help protect what matters most to your business while making a positive impact on our planet.
          </p>
          {error && (
            <p style={{ 
              color: 'red', 
              marginTop: '1rem', 
              fontSize: '0.9rem' 
            }}>
              {error}
            </p>
          )}
          <div style={{ 
            marginTop: '2rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            alignItems: 'center'
          }}>
            {/* Commented out dashboard access button
            <PrimaryButton 
              onClick={handleDashboardAccess} 
              disabled={loading}
              style={{ width: '100%', maxWidth: '300px' }}
            >
              {loading ? 'Accessing Dashboard...' : 'Access Your Dashboard'}
            </PrimaryButton>
            */}
            <PrimaryButton 
              onClick={handleReturnHome}
              style={{ 
                width: '100%', 
                maxWidth: '300px',
                backgroundColor: 'transparent',
                color: '#333',
                border: '1px solid #ccc'
              }}
            >
              Return to Homepage
            </PrimaryButton>
          </div>
        </div>
      </FormSection>
      <TestimonialSection>
        {/* <TestimonialCard
          quote="Finally, an insurance partner that makes sense for our values. Their platform is refreshingly simple to use, and we can finally see what our insurance impacts. As a B-Corporation, we love that our insurance now actively supports environmental initiatives while providing excellent coverage. It's insurance that actually aligns with our values."
          authorName="Louiza Ziane"
          authorRole="Co-founder, Toast Brewing"
          authorInitials="LZ"
        /> */}
      </TestimonialSection>
    </Container>
  );
};

export default ThankYouPage; 